import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import imageSelecter from '../../components/_image_selecter';
import multiImageUploader from '../../components/_multi_image_uploader';
import loop from '../../components/_loop-component';
import updateStorecreatorData from '../../components/_update_storecreator_data';
import modalCategoryEdit from '../../components/category/_modal_category_edit';
import optionEditor from './_option_editor_component';
import tableStockEditor from './_table_stock_editor_component';
import productCategorySelector from './_product_category_selector_component';
import brandSelector from './_brand_selector_component';
import specSelector from './_spec_selector_component';
import priceEditor from './_price_editor_component';
import leadtimeEditor from './_leadtime_editor_component';

// 最大商品詳細画像枚数
const MAX_LIB_IMAGES = 20;

/**
 * 商品情報編集コンポーネント
 */
export default {
    name: 'itemEditor',
    template: '#item_editor_component_template',
    data () {
        const weight_data = document.querySelector('[data-roll="weight_data"]');
        return {
            // 配送グループデータ
            delivery_groups: [],
            // 発送予定日一覧
            cart_lead_times: [],
            // 重量表示フラグ
            weight_flag: !!weight_data && JSON.parse(weight_data.innerHTML) ? JSON.parse(weight_data.innerHTML)['is_enable'] : false,
            //「個別商品価格」を設定するフラグ
            variant_price_show: false,
        };
    },
    props: {
        // v-model商品データ
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        // 新規追加の場合、最新カテゴリ一覧を渡す
        categories: {
            type: Array,
            default: () => ([]),
        },
        // 編集ID
        edit_id: {
            type: [String, Number],
            require: true
        }
    },
    /**
     * コンポーネント群
     */
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
        // 一括画像アップコンポーネント
        'multi-image-uploader': multiImageUploader,
        // 繰り返しコンポーネント
        'loop': loop,
        // ストアクリエイターからデータを取得するコンポーネント
        'update-storecreator-data': updateStorecreatorData,
        // カテゴリ管理コンポーネント
        'category': modalCategoryEdit,
        // 表在庫編集コンポーネント
        'table-stock-editor': tableStockEditor,
        // プロダクトコード選択コンポーネント
        'product-category-selector': productCategorySelector,
        // ブランド設定コンポーネント
        'brand-selector': brandSelector,
        // スペック設定コンポーネント
        'spec-selector': specSelector,
        // オプション編集コンポーネント
        'option-editor': optionEditor,
        // セール価格設定切り替えコンポーネント
        'price-editor': priceEditor,
        // 発送予定日コンポーネント
        'leadtime-editor': leadtimeEditor,
    },
    computed: {
        // 編集中の商品データ
        item_data: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        // 商品名
        itemName: {
            get() {
                return (this.hasItemData) ? this.item_data.name : '';
            },
            set(value) {
                // 全角スペースは半角に置換
                value = value.replace(/　/g, ' ');
                this.item_data.name = value;
            },
        },
        // 商品データが取得済みか
        hasItemData: function () {
            return (Object.keys(this.item_data).length > 0);
        },
        // 配送グループリストがあるか
        hasDeliveryGroups: function () {
            return (this.delivery_groups.length > 0);
        },
        // 発送予定日リストがあるか
        hasCartLeadTimes: function () {
            return (this.cart_lead_times.length > 0);
        },
        // 編集ページか否か
        isEditItem: function () {
            return (this.$_params('item_code') !== null);
        },
        // 表在庫か否か
        isTableStockType: function () {
            return (this.hasItemData && this.item_data.stock_config.type === 'table');
        },
        // メイン商品画像が指定、変更されているか
        isChangedItemImage: function () {
            if (!this.hasItemData) {
                return false;
            }
            const img = this.item_data.image_config;
            if (!img) {
                return false;
            }
            // dir/image.jpgのようなパス付きはテンプレート画像
            if (!/^https:\/\/.*/.test(img) && /\/[0-9a-zA-Z_-]*?\.(jpg|jpeg|gif|png)$/.test(img)) {
                return false;
            }
            return true;
        },
        // プロダクトカテゴリがセットされているか
        isValidProductCategory: function () {
            if (!this.hasItemData) {
                return false;
            }
            if (typeof this.item_data.product_category_config.code === 'undefined' || this.item_data.product_category_config.code === null) {
                return false;
            }
            if (this.item_data.product_category_config.code.length === 0) {
                return false;
            }
            return true;
        },
        // 表在庫の設定がされているか
        hasTableStockSetting: function () {
            return (this.item_data.subcodes_config.values.length > 0);
        },
        // 商品詳細追加ボタン表示
        showLibImagesAddBtn: function () {
            return (this.item_data.lib_images_config.length < MAX_LIB_IMAGES);
        },
        // 商品詳細画像があるか
        hasLibImages: function () {
            return (this.item_data.lib_images_config.length > 0);
        },
        // ブランドコードの設定がされているか否か
        hasBrandSetting: function () {
            return (this.hasItemData && typeof this.item_data.brand_code !== 'undefined' && this.item_data.brand_code !== null);
        },
        // スペックの設定がされているか否か
        hasSpecSetting: function () {
            return (this.hasItemData && typeof this.item_data.spec_config !== 'undefined' && this.item_data.spec_config?.length > 0);
        },
        // 在庫0での注文
        allowOverdraft: {
            get() {
                return Boolean(Number(this.item_data.stock_config.normal_stock_allow_overdraft));
            },
            set(value) {
                this.item_data.stock_config.normal_stock_allow_overdraft = (value) ? 1 : 0;
            },
        },
        // 在庫0での注文は無効か
        isDisabledAllowOverdraft: function () {
            const values = this.item_data.subcodes_config.values;
            let standard = null;
            for (let rowIndex in values) {
                // 基準となるallow_overdraftと一致しない箇所がないか検査
                const unmatchedIndex = values[rowIndex].findIndex(function(value) {
                    // allow_overdraftが存在しないなら検査対象外
                    if (!value.allow_overdraft) {
                        return false;
                    }
                    // チェックの基準となるallow_overdraftを決める
                    if (!standard) {
                        standard = value.allow_overdraft;
                    }
                    // 基準の設定と合致しなければtrue
                    return value.allow_overdraft !== standard;
                });

                // マッチしない箇所が一つでもある
                if (unmatchedIndex > -1) {
                    // 超過可/不可が混在するため無効にする
                    return true;
                }
            }
            // 無効にしない
            return false;
        },
        // カテゴリがアプリに存在するか
        categoryExistOnApp: function () {
            return this.item_data.path_config !== null;
        },
        // ストアカテゴリパスリスト
        rawStoreCategoyPathList: function () {
            let pathList =  _.cloneDeep(this.item_data.path_list);
            // データが一つの場合オブジェクトになるため配列化
            if (!Array.isArray(pathList.path)) {
                pathList.path = [pathList.path];
            }
            return pathList.path.map(path => {
                let replacedPath = path.content.replace(':', ' ＞ ');
                replacedPath = this.$_unEscape(replacedPath.replace(/;amp;/g, ';'));
                return 'ストアトップ ＞ ' + replacedPath;
            }, this);
        },
        /**
         * 詳細画像リストを返却する
         * @returns {Array}
         */
        validateLibImagesConfig: function () {
            const libImagesConfig =  _.cloneDeep(this.item_data.lib_images_config);
            const shopId = this.config.user.shop_id;
            const itemCode = this.item_data.item_code;

            // 条件1: shop_id + item_code を含む (=同じ商品の画像である)
            // 条件2: /lib/{shop_id}/ を含む (=追加画像である)
            const variationImageRegex = new RegExp(`^https://.*(${shopId}_${itemCode}|/lib/${shopId}/).*$`);
            return libImagesConfig.map((libImageConfig) => {
                // バリエーション画像として有効か
                libImageConfig.disabled = !variationImageRegex.test(libImageConfig.image);
                return libImageConfig;
            });
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    emits: [
        'update:modelValue',
        'next-step',
    ],
    watch: {
        // v-modelの商品データがセットされたら
        modelValue: {
            handler() {
                // カテゴリデータ更新
                this.$nextTick(function() {
                    if (Object.keys(this.categories).length > 0 && typeof this.$refs.category !== 'undefined') {
                        this.$refs.category.setCategories(this.categories);
                    }
                });
            },
            immediate: true,
        },
        // プロダクトコードが変更されたらスペックとブランドコードを初期化する
        ['item_data.product_category_config.code']: function (newValue, oldValue) {
            // oldValueがない(初回)場合はスキップ
            if (typeof oldValue === 'undefined') {
                return;
            }

            if (this.hasBrandSetting) {
                this.brandClear();
            }

            if (this.hasSpecSetting) {
                this.specClear();
            }

            return;
        }
    },
    methods: {
        show: function() {
            this.$refs.category.show();
        },
        // ブランドコードを初期化する
        brandClear: function () {
            this.item_data.brand_code = null;
            console.log('brand clear');
        },
        // スペック情報を初期化する
        specClear: function () {
            let options = _.cloneDeep(this.item_data.options_config);
            for (const i in options) {
                options[i].spec_id = '';
                for (const j in options[i].values) {
                    options[i].values[j].spec_value = '';
                }
            }
            this.item_data.options_config = options;
            this.item_data.spec_config = [];
            console.log('spec clear');
        },
        // 商品コードが重複していないか
        isUniqueItemCode: async function () {
            let isUnique = false;
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await yahooAxios.get('/item/is_unique_item_code', {
                    params: {
                        item_code: this.item_data.item_code,
                    }
                });
                isUnique = response.data.data;
                message = '';
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            return isUnique;
        },
        // 商品詳細画像を全てクリアする
        clearAllLibImages: async function () {
            if (await swalConfirm('削除しますが宜しいですか？')) {
                this.$refs.lib_images.removeAll();
            }
        },
        // バリデーション
        validation: async function () {
            const $form = this.$refs.itemForm;

            // 価格設定のバリデーションエラーがあるタブへ予め切り替えておく
            await this.$refs.priceEditor.changeValidErrorTab();

            // 通常のHTML5バリデーションエラー
            if (!$form.checkValidity()) {
                $form.reportValidity();
                return false;
            }

            // 以下カスタムバリデーション

            // 商品名にテスト、の文言があるとダメ
            if (!this.isEditItem && /テスト|test/.test(this.item_data.name)) {
                this.$refs.itemNameInput.setCustomValidity('「テスト・test」の文字があると開店審査に通りません');
                $form.reportValidity();
                return false;
            }
            // 商品コードフォーマットチェック
            if (!this.isEditItem && !/^[a-z0-9-]*$/.test(this.item_data.item_code)) {
                this.$refs.itemCodeInput.setCustomValidity('商品コードは「abc123」などの半角小文字英数字、ハイフンのみ使用可能です');
                $form.reportValidity();
                return false;
            }
            // 商品コード重複チェック
            if (!this.isEditItem && !await this.isUniqueItemCode()) {
                this.$refs.itemCodeInput.setCustomValidity('この商品コードはすでに使われています');
                $form.reportValidity();
                return false;
            }
            return true;
        },
        // 次のステップへ
        next: async function (event) {
            event.preventDefault();
            // 次へ(テンプレート編集(admin)はバリデーションしない)
            if (this.isAdmin || await this.validation()) {
                this.emitNextStep();
            }
        },

        // -------------------------
        // emit
        // -------------------------

        // 次のステップへを親へ通知
        emitNextStep: function () {
            this.$emit('next-step');
        }
    }
};
